<div>
  <h1 class="text-2xl font-semibold text-slate-900">Settings</h1>
  <p class="mt-1 text-sm text-slate-500">
    Control how Mistbelle reaches you about orders and offers.
  </p>
</div>

@if (notice()) {
  <output
    class="mt-4 block rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
  >
    {{ notice() }}
  </output>
}

<div class="mt-6 rounded-xl border border-slate-200">
  <div class="border-b border-slate-100 px-4 py-3 sm:px-5">
    <h2 class="text-sm font-semibold text-slate-900">Notifications</h2>
  </div>

  <div class="divide-y divide-slate-100">
    <div class="flex items-center justify-between gap-4 px-4 py-4 sm:px-5">
      <div>
        <p class="text-sm font-medium text-slate-900">Email</p>
        <p class="text-xs text-slate-500">Order updates and offers</p>
      </div>
      <button
        type="button"
        role="switch"
        [attr.aria-checked]="emailNotifications()"
        aria-label="Toggle email notifications"
        [disabled]="isPending('MARKETING', 'emailEnabled')"
        (click)="toggleEmail()"
        class="relative h-7 w-12 shrink-0 rounded-full transition-colors disabled:cursor-wait disabled:opacity-70"
        [class.bg-primary-700]="emailNotifications()"
        [class.bg-slate-300]="!emailNotifications()"
      >
        <span
          class="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all"
          [class.left-5]="emailNotifications()"
          [class.left-0.5]="!emailNotifications()"
        ></span>
      </button>
    </div>

    <div class="flex items-center justify-between gap-4 px-4 py-4 sm:px-5">
      <div>
        <p class="text-sm font-medium text-slate-900">SMS</p>
        <p class="text-xs text-slate-500">Delivery alerts on your phone</p>
      </div>
      <button
        type="button"
        role="switch"
        [attr.aria-checked]="smsNotifications()"
        aria-label="Toggle SMS notifications"
        [disabled]="isPending('ORDER_UPDATES', 'smsEnabled')"
        (click)="toggleSms()"
        class="relative h-7 w-12 shrink-0 rounded-full transition-colors disabled:cursor-wait disabled:opacity-70"
        [class.bg-primary-700]="smsNotifications()"
        [class.bg-slate-300]="!smsNotifications()"
      >
        <span
          class="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all"
          [class.left-5]="smsNotifications()"
          [class.left-0.5]="!smsNotifications()"
        ></span>
      </button>
    </div>

    <div class="flex items-center justify-between gap-4 px-4 py-4 sm:px-5">
      <div>
        <p class="text-sm font-medium text-slate-900">Push</p>
        <p class="text-xs text-slate-500">App and browser reminders</p>
      </div>
      <button
        type="button"
        role="switch"
        [attr.aria-checked]="pushNotifications()"
        aria-label="Toggle push notifications"
        [disabled]="isPending('ORDER_UPDATES', 'pushEnabled')"
        (click)="togglePush()"
        class="relative h-7 w-12 shrink-0 rounded-full transition-colors disabled:cursor-wait disabled:opacity-70"
        [class.bg-primary-700]="pushNotifications()"
        [class.bg-slate-300]="!pushNotifications()"
      >
        <span
          class="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all"
          [class.left-5]="pushNotifications()"
          [class.left-0.5]="!pushNotifications()"
        ></span>
      </button>
    </div>
  </div>
</div>
